export const rsStormSewers = [
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.0",
    Description: "ADOPTED SEWERS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipework, GBS, backfilled with 6F2, deposit surplus material on site ",
    Qty: "339",
    Unit: "m",
    Rate: "n/a",
    Amount: "£47,480.33",
  },
  {
    Item: "",
    Description: "EO for 225mmØ stub/rocker pipe",
    Qty: "28",
    Unit: "nr",
    Rate: "47.38",
    Amount: "£1,326.64",
  },
  {
    Item: "",
    Description: "EO for 225 x 150mm junction",
    Qty: "14",
    Unit: "nr",
    Rate: "175.69",
    Amount: "£2,459.66",
  },
  {
    Item: "",
    Description: "EO for reinforced concrete protection paving to 225mmØ pipe",
    Qty: "7",
    Unit: "m",
    Rate: "83.30",
    Amount: "£583.10",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "300mmØ pipework, GBS, backfilled with 6F2, deposit surplus material on site ",
    Qty: "356",
    Unit: "m",
    Rate: "n/a",
    Amount: "£58,636.36",
  },
  {
    Item: "",
    Description: "EO for 300mmØ stub/rocker pipe",
    Qty: "22",
    Unit: "nr",
    Rate: "56.07",
    Amount: "£1,233.54",
  },
  {
    Item: "",
    Description: "EO for 300 x 150mm junction",
    Qty: "34",
    Unit: "nr",
    Rate: "158.08",
    Amount: "£5,374.72",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "375mmØ pipework, GBS, backfilled with 6F2, deposit surplus material on site ",
    Qty: "182",
    Unit: "m",
    Rate: "n/a",
    Amount: "£40,437.51",
  },
  {
    Item: "",
    Description: "EO for 375mmØ stub/rocker pipe",
    Qty: "14",
    Unit: "nr",
    Rate: "71.09",
    Amount: "£995.26",
  },
  {
    Item: "",
    Description: "EO for 375 x 150mm junction",
    Qty: "17",
    Unit: "nr",
    Rate: "200.55",
    Amount: "£3,409.35",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "450mmØ pipework, GBS, backfilled with 6F2, deposit surplus material on site ",
    Qty: "135",
    Unit: "m",
    Rate: "n/a",
    Amount: "£32,374.58",
  },
  {
    Item: "",
    Description: "EO for 450mmØ stub/rocker pipe",
    Qty: "12",
    Unit: "nr",
    Rate: "87.66",
    Amount: "£1,051.92",
  },
  {
    Item: "",
    Description: "EO for 450 x 150mm junction",
    Qty: "14",
    Unit: "nr",
    Rate: "242.55",
    Amount: "£3,395.70",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "525mmØ pipework, GBS, backfilled with 6F2, deposit surplus material on site ",
    Qty: "318",
    Unit: "m",
    Rate: "n/a",
    Amount: "£80,229.51",
  },
  {
    Item: "",
    Description: "EO for 525mmØ stub/rocker pipe",
    Qty: "32",
    Unit: "nr",
    Rate: "115.33",
    Amount: "£3,690.56",
  },
  {
    Item: "",
    Description: "EO for core drilling 525mm pipework",
    Qty: "31",
    Unit: "nr",
    Rate: "251.25",
    Amount: "£7,788.75",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "600mmØ pipework, GBS, backfilled with 6F2, deposit surplus material on site ",
    Qty: "51",
    Unit: "m",
    Rate: "n/a",
    Amount: "£17,114.07",
  },
  {
    Item: "",
    Description: "EO for 600mmØ stub/rocker pipe",
    Qty: "4",
    Unit: "nr",
    Rate: "146.53",
    Amount: "£586.12",
  },
  {
    Item: "",
    Description: "EO for core drilling 600mm pipework",
    Qty: "6",
    Unit: "nr",
    Rate: "251.25",
    Amount: "£1,507.50",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "675mmØ pipework, GBS, backfilled with 6F2, deposit surplus material on site ",
    Qty: "102",
    Unit: "m",
    Rate: "n/a",
    Amount: "£35,379.02",
  },
  {
    Item: "",
    Description: "EO for 675mmØ stub/rocker pipe",
    Qty: "10",
    Unit: "nr",
    Rate: "199.64",
    Amount: "£1,996.40",
  },
  {
    Item: "",
    Description: "EO for core drilling 675mm pipework",
    Qty: "7",
    Unit: "nr",
    Rate: "251.25",
    Amount: "£1,758.75",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.0",
    Description: "LATERAL CONNECTIONS - PROVISIONAL SUM, NO LEVELS INFO",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipework, GBS, backfilled with 6F2, deposit surplus material on site ",
    Qty: "349",
    Unit: "m",
    Rate: "n/a",
    Amount: "£37,377.40",
  },
  {
    Item: "",
    Description: "EO for 150mmØ stub/rocker pipe",
    Qty: "114",
    Unit: "nr",
    Rate: "21.76",
    Amount: "£2,480.64",
  },
  {
    Item: "",
    Description: "EO for concrete bed & surround to 150mmØ pipe",
    Qty: "4",
    Unit: "m",
    Rate: "33.04",
    Amount: "£132.16",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "3.0",
    Description: "GULLY CONNECTIONS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipework, GBS, backfilled with 6F2, deposit surplus material on site ",
    Qty: "555",
    Unit: "m",
    Rate: "n/a",
    Amount: "£40,575.46",
  },
  {
    Item: "",
    Description: "EO for 150mmØ stub/rocker pipe",
    Qty: "43",
    Unit: "nr",
    Rate: "21.76",
    Amount: "£935.68",
  },
  {
    Item: "",
    Description: "EO for concrete bed & surround to 150mmØ pipe",
    Qty: "422",
    Unit: "m",
    Rate: "33.04",
    Amount: "£13,942.88",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.0",
    Description: "PCC MANHOLES ",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm diameter manhole - PCC chamber rings",
    Qty: "7",
    Unit: "nr",
    Rate: "n/a",
    Amount: "£16,923.35",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "1350mm diameter manhole - PCC chamber rings",
    Qty: "31",
    Unit: "nr",
    Rate: "n/a",
    Amount: "£78,950.89",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "1500mm diameter manhole - PCC chamber rings",
    Qty: "16",
    Unit: "nr",
    Rate: "n/a",
    Amount: "£50,146.24",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Flow Control Chamber - 2700mmØ PCC MH at 2.50m dti - 2.0 l/s - S19",
    Qty: "1",
    Unit: "nr",
    Rate: "13444.28",
    Amount: "£13,444.28",
  },
  {
    Item: "",
    Description:
      "Flow Control Chamber - 2700mmØ PCC MH at 2.50m dti - 200.0 l/s - S45",
    Qty: "1",
    Unit: "nr",
    Rate: "19489.36",
    Amount: "£19,489.36",
  },
  {
    Item: "",
    Description:
      "Flow Control Chamber - 2700mmØ PCC MH at 2.75m dti - 18.0 l/s - S62",
    Qty: "1",
    Unit: "nr",
    Rate: "16028.89",
    Amount: "£16,028.89",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply and fit temporary debris grille to outfall manhole",
    Qty: "1",
    Unit: "nr",
    Rate: "1502.48",
    Amount: "£1,502.48",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "5.0",
    Description: "PCC ROAD GULLEY",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Precast concrete road gulley 450 x 900 inc grate & frame ",
    Qty: "166",
    Unit: "nr",
    Rate: "432.02",
    Amount: "£71,715.32",
  },
  {
    Item: "",
    Description: "Hessian and straw protection to gully",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "Preformed gully guards",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "6.0",
    Description: "DEMARCATION CHAMBERS - PROVISIONAL SUM, NO LEVELS INFO",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Demarcation chamber - NME PPIC - 1.2 - 3.0m deep",
    Qty: "57",
    Unit: "nr",
    Rate: "964.80",
    Amount: "£54,993.60",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "7.0",
    Description: "PONDS, SWALES & HEADWALLS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "ATTENUATION POND A (1m BELOW EGL FOLLOWING WOODLAND REMOVAL)",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Site strip to remove vegetation",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "By Others",
  },
  {
    Item: "",
    Description:
      "Excavate to reduce levels to take up top soil, deposit onsite",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "By Others",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Excavate to reduce levels",
    Qty: "3061",
    Unit: "m³",
    Rate: "5.06",
    Amount: "£15,488.66",
  },
  {
    Item: "",
    Description: "Filling with site won subsoil",
    Qty: "405",
    Unit: "m³",
    Rate: "7.12",
    Amount: "£2,883.60",
  },
  {
    Item: "",
    Description: "Level and compact formation, batter embankments",
    Qty: "3198",
    Unit: "m²",
    Rate: "1.09",
    Amount: "£3,485.82",
  },
  {
    Item: "",
    Description: "Impermeable Pond liner (Permanent wet area)",
    Qty: "531",
    Unit: "m²",
    Rate: "18.09",
    Amount: "£9,605.79",
  },
  {
    Item: "",
    Description: "Spread and level 150mm thick top soil",
    Qty: "3198",
    Unit: "m²",
    Rate: "2.86",
    Amount: "£9,146.28",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "ATTENUATION POND B (1m BELOW EGL FOLLOWING WOODLAND REMOVAL)",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Site strip to remove vegetation",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "By Others",
  },
  {
    Item: "",
    Description:
      "Excavate to reduce levels to take up top soil, deposit onsite",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "By Others",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Excavate to reduce levels",
    Qty: "781",
    Unit: "m³",
    Rate: "5.06",
    Amount: "£3,951.86",
  },
  {
    Item: "",
    Description: "Filling with site won subsoil",
    Qty: "14",
    Unit: "m³",
    Rate: "7.12",
    Amount: "£99.68",
  },
  {
    Item: "",
    Description: "Level and compact formation, batter embankments",
    Qty: "827",
    Unit: "m²",
    Rate: "1.09",
    Amount: "£901.43",
  },
  {
    Item: "",
    Description: "Impermeable Pond liner (Permanent wet area)",
    Qty: "134",
    Unit: "m²",
    Rate: "18.09",
    Amount: "£2,424.06",
  },
  {
    Item: "",
    Description:
      "1200mm wide channel lined with 75-100mm boulders + stone pitching",
    Qty: "12",
    Unit: "m",
    Rate: "211.33",
    Amount: "£2,535.96",
  },
  {
    Item: "",
    Description: "Spread and level 150mm thick top soil",
    Qty: "827",
    Unit: "m²",
    Rate: "2.86",
    Amount: "£2,365.22",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "ATTENUATION POND C",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Site strip to remove vegetation",
    Qty: "2101",
    Unit: "m²",
    Rate: "1.25",
    Amount: "£2,626.25",
  },
  {
    Item: "",
    Description:
      "Excavate to reduce levels to take up 334mm top soil, deposit onsite",
    Qty: "702",
    Unit: "m³",
    Rate: "5.06",
    Amount: "£3,552.12",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Excavate to reduce levels",
    Qty: "1725",
    Unit: "m³",
    Rate: "5.06",
    Amount: "£8,728.50",
  },
  {
    Item: "",
    Description: "Filling with site won subsoil",
    Qty: "670",
    Unit: "m³",
    Rate: "7.12",
    Amount: "£4,770.40",
  },
  {
    Item: "",
    Description: "Level and compact formation, batter embankments",
    Qty: "2211",
    Unit: "m²",
    Rate: "1.09",
    Amount: "£2,409.99",
  },
  {
    Item: "",
    Description: "Impermeable Pond liner (Permanent wet area)",
    Qty: "157",
    Unit: "m²",
    Rate: "18.09",
    Amount: "£2,840.13",
  },
  {
    Item: "",
    Description: "Spread and level 150mm thick top soil",
    Qty: "2211",
    Unit: "m²",
    Rate: "2.86",
    Amount: "£6,323.46",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "HEADWALLS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "HW1,3 to suit 525mmØ pipe - INLET",
    Qty: "2",
    Unit: "nr",
    Rate: "12276.33",
    Amount: "£24,552.66",
  },
  {
    Item: "",
    Description: "HW 2,4 to suit 525mmØ pipe - OUTLET",
    Qty: "2",
    Unit: "nr",
    Rate: "11953.04",
    Amount: "£23,906.08",
  },
  {
    Item: "",
    Description: "HW5 to suit 675mmØ pipe - INLET",
    Qty: "1",
    Unit: "nr",
    Rate: "12836.76",
    Amount: "£12,836.76",
  },
  {
    Item: "",
    Description: "HW6, 7 to suit 675mmØ pipe - OUTLET",
    Qty: "2",
    Unit: "nr",
    Rate: "12235.13",
    Amount: "£24,470.26",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Civilise existing ditchcourse immediately adjacent outfall headwall",
    Qty: "1",
    Unit: "item",
    Rate: "532.65",
    Amount: "£532.65",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "8.0",
    Description: "NORTH WATERCOURSE DIVERSION",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "ADOPTED SEWERS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "375mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "86",
    Unit: "m",
    Rate: "n/a",
    Amount: "£13,350.20",
  },
  {
    Item: "",
    Description: "EO for 375mmØ stub/rocker pipe",
    Qty: "12",
    Unit: "nr",
    Rate: "71.09",
    Amount: "£853.08",
  },
  {
    Item: "",
    Description: "Concrete protection paving",
    Qty: "30",
    Unit: "nr",
    Rate: "93.37",
    Amount: "£2,801.10",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "525mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "4",
    Unit: "m",
    Rate: "n/a",
    Amount: "£754.20",
  },
  {
    Item: "",
    Description: "EO for 525mmØ stub/rocker pipe",
    Qty: "2",
    Unit: "nr",
    Rate: "115.33",
    Amount: "£230.66",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "BRICK CHAMBERS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "1550 x 0.875m Brick chamber - 1.25m deep",
    Qty: "2",
    Unit: "nr",
    Rate: "2871.72",
    Amount: "£5,743.44",
  },
  {
    Item: "",
    Description: "1550 x 0.875m Brick chamber - 1.50m deep",
    Qty: "2",
    Unit: "nr",
    Rate: "3418.95",
    Amount: "£6,837.90",
  },
  {
    Item: "",
    Description: "1550 x 0.875m Brick chamber - 1.75m deep",
    Qty: "1",
    Unit: "nr",
    Rate: "3952.31",
    Amount: "£3,952.31",
  },
  {
    Item: "",
    Description: "EO construct manhole on existing sewer",
    Qty: "1",
    Unit: "nr",
    Rate: "904.50",
    Amount: "£904.50",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "OPEN DITCH COURSE",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Site strip to remove vegetation",
    Qty: "302",
    Unit: "m²",
    Rate: "1.25",
    Amount: "£377.50",
  },
  {
    Item: "",
    Description:
      "Excavate to reduce levels to take up 334mm top soil, deposit onsite",
    Qty: "101",
    Unit: "m³",
    Rate: "5.06",
    Amount: "£511.06",
  },
  {
    Item: "",
    Description: "Excavate to reduce levels",
    Qty: "168",
    Unit: "m³",
    Rate: "5.06",
    Amount: "£850.08",
  },
  {
    Item: "",
    Description: "Spread and level 150mm thick top soil",
    Qty: "340",
    Unit: "m²",
    Rate: "2.86",
    Amount: "£972.40",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "HW to suit 375mmØ pipe",
    Qty: "4",
    Unit: "nr",
    Rate: "4642.16",
    Amount: "£18,568.64",
  },
  {
    Item: "",
    Description: "HW to suit 525mmØ pipe",
    Qty: "1",
    Unit: "nr",
    Rate: "5541.26",
    Amount: "£5,541.26",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "9.0",
    Description: "DITCH & CULVERT BIRMINGHAM ROAD BOUNDARY (POND A - POND B)",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Site strip to remove vegetation",
    Qty: "878",
    Unit: "m²",
    Rate: "1.25",
    Amount: "£1,097.50",
  },
  {
    Item: "",
    Description:
      "Excavate to reduce levels to take up 334mm top soil, deposit onsite",
    Qty: "293",
    Unit: "m³",
    Rate: "5.06",
    Amount: "£1,482.58",
  },
  {
    Item: "",
    Description: "Excavate to reduce levels",
    Qty: "197",
    Unit: "m³",
    Rate: "5.06",
    Amount: "£996.82",
  },
  {
    Item: "",
    Description: "Spread and level 150mm thick top soil",
    Qty: "772",
    Unit: "m²",
    Rate: "2.86",
    Amount: "£2,207.92",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225dia pipe, GBS, backfill with Type 1, deposit surplus arisnings onsite dti 1.00m",
    Qty: "24",
    Unit: "m",
    Rate: "84.21",
    Amount: "£2,021.04",
  },
  {
    Item: "",
    Description: "Brick headwall - Provisional, pending design",
    Qty: "2",
    Unit: "nr",
    Rate: "2261.25",
    Amount: "£4,522.50",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "10.0",
    Description: "TESTING",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Clegg monitor testing of sewer backfill (500mm layer depths at 30 metre intervals)",
    Qty: "1",
    Unit: "item",
    Rate: "14381.55",
    Amount: "£14,381.55",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "11.0",
    Description: "COMBINED POND (1m BELOW EGL FOLLOWING WOODLAND REMOVAL)",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "PROVISIONAL SUM, NO DETAILS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Site strip to remove vegetation",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "By Others",
  },
  {
    Item: "",
    Description:
      "Excavate to reduce levels to take up top soil, deposit onsite",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "By Others",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Excavate to reduce levels",
    Qty: "1939",
    Unit: "m³",
    Rate: "5.06",
    Amount: "£9,811.34",
  },
  {
    Item: "",
    Description: "Filling with site won subsoil",
    Qty: "142",
    Unit: "m³",
    Rate: "7.12",
    Amount: "£1,011.04",
  },
  {
    Item: "",
    Description: "Level and compact formation, batter embankments",
    Qty: "3434",
    Unit: "m²",
    Rate: "1.09",
    Amount: "£3,743.06",
  },
  {
    Item: "",
    Description: "Impermeable Pond liner (Permanent wet area)",
    Qty: "",
    Unit: "m²",
    Rate: "18.09",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "Spread and level 150mm thick top soil",
    Qty: "3434",
    Unit: "m²",
    Rate: "2.86",
    Amount: "£9,821.24",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£1,051,230.52",
  },
];
